import script from "./LockerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LockerPage.vue?vue&type=script&setup=true&lang=js"

import "./LockerPage.vue?vue&type=style&index=0&id=2e47c30e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e47c30e"]])

export default __exports__